import DeleteAddressModal from './DeleteAddressModal'

export default DeleteAddressModal
